import styles from "./index.module.less";

/**
 * 页面信息 提供给SEO使用的页面介绍信息
 * 需求文档： https://doc.huanleguang.com/pages/viewpage.action?pageId=281253843
 * @param {{title: string, desc: string}} props
 * @returns
 */
export default function PageInfo(props) {
  const { title, desc } = props;

  if (!title) return null;

  return (
    <div className={styles.pageInfo}>
      <h1>{title}</h1>
      <div>{desc}</div>
    </div>
  );
}
